import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CrearContrarecibosEdit } from "./edit";

export type Entity = string[];
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


/**
* Modal para crear un contrarecibo
*/
export class GenerarContrarecibosModalEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Seleccionar guías para facturar"
                fullScreen
            >
                <CrearContrarecibosEdit value={value} onChange={this.props.onChange}  />
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/modal.tsx